export default __webpack_public_path__ + "static/media/Sinister Tunic.ed658fdf.jpg";